// +----------------------------------------------------------------------
// | 选择分布条：把「大家最后选了什么」画成一条横向占比条 + 图例
// |
// | 这是全站唯一展示「匿名聚合数字」的地方，两条原则：
// |   1. 样本不够（percent 为 null）就只报人数，不画百分比 —— 人少了
// |      「大多数」这个词没有意义，宁可少说
// |   2. 颜色只是区分选项，不用红绿暗示好坏 —— 别人的选择不是参考答案
// +----------------------------------------------------------------------
import './TopicBars.less';

export default function TopicBars({ options = [], available = true, compact = false, showLegend = true }) {
  if (!options || options.length === 0) {
    return (
      <p className="topic-bars-empty muted">
        还没有人做出选择，等有人选了这里就会有分布。
      </p>
    );
  }

  const total = options.reduce((sum, item) => sum + Number(item.count || 0), 0);

  return (
    <div className={`topic-bars ${compact ? 'is-compact' : ''}`}>
      {available && (
        <div className="topic-bars-track">
          {options.map((item, index) => (
            <span
              key={item.name}
              className={`topic-bars-seg seg-${index % 6}`}
              style={{ width: `${Number(item.percent || 0)}%` }}
              title={`${item.name} ${item.percent}%`}
            />
          ))}
        </div>
      )}

      {showLegend && (
        <ul className="topic-bars-legend">
          {options.map((item, index) => (
            <li key={item.name} className="topic-bars-item">
              <span className={`topic-bars-dot seg-${index % 6}`} />
              <span className="topic-bars-name" title={item.name}>
                {item.name}
              </span>
              <span className="topic-bars-count muted">
                {item.count}
                {total > 0 ? ` / ${total} 人` : ' 人'}
              </span>
              {available && item.percent !== null && (
                <span className="topic-bars-percent">{item.percent}%</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
